/* eslint-disable */

(function (Drupal, $) {
  Drupal.behaviors.scrollToHash = {
    attach: function (context) {
      'use strict';

      $(document).ready(function () {
        var initialized;

        function init() {
          if (!initialized) {
            initialized = true;

            if (window.location.hash) {
              var hash = window.location.hash;

              if ($(hash).length) {
                $('html, body').animate({ scrollTop: $(hash).offset().top - 150 }, 250, 'linear');
              }
            }

            $('a[href^="#"]').click(function (event) {

              if (this.hash !== '') {
                event.preventDefault();
                var hash = this.hash;
               if ($(hash).length ) {
                history.pushState({}, '', hash);
                $('html, body').animate({ scrollTop: $(hash).offset().top - 150 }, 250, 'linear');
               }
               }
            });
          }
        }

        init();
      });
    },
  };
})(Drupal, jQuery);
